import * as moment from "moment";

export function subtractDays(date, noOfDays) {
  return moment(date).subtract(noOfDays, "days").toDate();
}

export function addDays(date, noOfDays) {
  return moment(date).add(noOfDays, "days").toDate();
}
